var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.89997 3.59999C8.89997 5.42253 7.42251 6.89999 5.59998 6.89999C3.77744 6.89999 2.29998 5.42253 2.29998 3.59999C2.29998 1.77745 3.77744 0.299988 5.59998 0.299988C7.42251 0.299988 8.89997 1.77745 8.89997 3.59999Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7 3.59999C17.7 5.42253 16.2225 6.89999 14.4 6.89999C12.5774 6.89999 11.1 5.42253 11.1 3.59999C11.1 1.77745 12.5774 0.299988 14.4 0.299988C16.2225 0.299988 17.7 1.77745 17.7 3.59999Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.222 15.7C13.2734 15.3407 13.3 14.9735 13.3 14.6C13.3 12.8013 12.6833 11.1466 11.6497 9.83596C12.4587 9.36789 13.3981 9.09999 14.4 9.09999C17.4376 9.09999 19.9 11.5624 19.9 14.6V15.7H13.222Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.59998 9.09999C8.63754 9.09999 11.1 11.5624 11.1 14.6V15.7H0.0999756V14.6C0.0999756 11.5624 2.56241 9.09999 5.59998 9.09999Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.26c0b572620c43bfaaae26302fed9e0f.svg";
export { ForwardRef as ReactComponent };